var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H13V11H5V14L0 10L5 6V9ZM3.99927 16H6.70835C8.11862 17.2447 9.97111 18 12 18C16.4183 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C9.97111 2 8.11862 2.75527 6.70835 4H3.99927C5.82368 1.57111 8.72836 0 12 0C17.5228 0 22 4.47715 22 10C22 15.5228 17.5228 20 12 20C8.72836 20 5.82368 18.4289 3.99927 16Z",
    fill: "#212348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/Signout.dee8f6acd9e7fd5649ef59cc640b36ed.svg";
export { ForwardRef as ReactComponent };